var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPesquisaStakeholders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 92,
    viewBox: "0 0 64 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2737 55.5192C16.4001 55.5192 4.32874 61.5549 4.32874 68.9917C4.32874 75.0274 12.2506 80.12 23.1902 81.8445V90.5477L33.9682 79.7697L23.1902 68.9917V76.3477C14.7026 74.8388 9.71774 71.2282 9.71774 68.9917C9.71774 66.1356 17.909 60.9082 31.2737 60.9082C44.6385 60.9082 52.8297 66.1356 52.8297 68.9917C52.8297 70.9587 48.8958 74.0843 42.0517 75.8088V81.3325C51.5633 79.2578 58.2187 74.5155 58.2187 68.9917C58.2187 61.5549 46.1474 55.5192 31.2737 55.5192Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5503 0.461548C16.3822 0.461548 4.92322 11.9205 4.92322 26.0886C4.92322 45.3089 30.5503 73.6817 30.5503 73.6817C30.5503 73.6817 56.1773 45.3089 56.1773 26.0886C56.1773 11.9205 44.7184 0.461548 30.5503 0.461548ZM30.5505 35.2413C25.4983 35.2413 21.398 31.141 21.398 26.0888C21.398 21.0366 25.4983 16.9363 30.5505 16.9363C35.6027 16.9363 39.703 21.0366 39.703 26.0888C39.703 31.141 35.6027 35.2413 30.5505 35.2413Z",
    fill: "#233863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesquisaStakeholders);
export default __webpack_public_path__ + "static/media/PesquisaStakeholders.528d8cdcbdb95fa3d15faca1d17c4654.svg";
export { ForwardRef as ReactComponent };